import { NextPage } from 'next';
import { Fragment, useState } from 'react';
// -------- custom component -------- //
import { LocalSEO } from 'components/blocks/portfolio';
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO';
import * as All from 'data/keywords';
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'SEO for Estate Agents',
  categories: 'multilingual seo',
  description: 'SEO for Estate Agents',
  parentDirectories: 'seo-design-portfolio'
};

const Portfolio = All.LocalSEOArrays[1].keywords;

const ProjectDetails: NextPage = () => {
  return (
    <Fragment>
      {/* <PageProgress /> */}{' '}
      <main className="content-wrapper">
        {/* ========== SEO META values ========== */}

        <SEO
          title={`${Portfolio[1].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
          urlENPT={``}
          url={`${Portfolio[1].url}/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />

        {/* ========== heading section ========== */}
        <section className="overflow-hidden position-relative cardboard">
          <div className="color w-100"></div>
          <div className="container gx-0 text-center wrapper h-md-auto">
            <div className="hero-portfolio">
              <img
                className="w-auto mx-auto"
                style={{ transform: 'scale(0.8)', maxWidth: '100% !important' }}
                src={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg.jpg`}
                // srcSet={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg@2x.jpg 2x`}
                alt={`${Portfolio[1].title}`}
              />
            </div>
          </div>
        </section>

        <section className="wrapper bg-light wrapper-border">
          {/* ========== details section ========== */}
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className="display-6 mb-4">{details.pageName}</h2>
                <div className="row">
                  <div className="col-md-8 text-justify">
                    <p style={{ maxWidth: 500 }}>
                      <img
                        width={120}
                        height={'auto'}
                        src={`/img/${All.localSEOPackages[1].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                        alt={All.localSEOPackages[1].title}
                        style={{ background: 'transparent', float: 'right' }}
                        className="mb-5 ms-3"
                        // align="right"
                      />
                      <ul>
                        <li>Client: Strutt and Parker</li>
                        <li>SEO Service Provider: SEOptimist</li>
                        <li>Web Design Partner: SAS Design</li>
                        <li>Industry: Real Estate</li>
                        <li>Project Timeline: [Insert Timeline]</li>
                        <li>
                          Objective: To enhance online visibility and user engagement through optimized SEO practices.
                        </li>
                      </ul>
                    </p>
                    <h2>Background and Challenge</h2>
                    <p>
                      Strutt and Parker, a prominent UK-based real estate agency, aimed to enhance their digital
                      presence to improve property listings visibility and user engagement. The real estate market's
                      competitiveness necessitated a robust SEO strategy that could place Strutt and Parker above its
                      competitors in search engine results.
                    </p>
                    <p>
                      SEOptimist was approached by SAS Design, the agency responsible for redesigning Strutt and Parker's
                      website, to provide comprehensive SEO services. The primary challenge was to integrate effective
                      SEO practices without compromising the website’s design and user experience.
                    </p>
                    <h3>Strategic Approach</h3>
                    <p>
                      SEOptimist’s approach was multifaceted, focusing on keyword research, page template construction,
                      code optimization, and accessibility improvements. Here's how each component was tackled:
                    </p>
                    <ol>
                      <li>
                        <strong>Keyword Research</strong>
                        <br />
                        SEOptimist conducted extensive keyword research to identify high-value keywords relevant to the
                        real estate market and particularly pertinent to Strutt and Parker’s offerings. The research
                        included analyzing search volume, keyword difficulty, and user intent.
                      </li>
                      <li>
                        <strong>Page Template Construction</strong>
                        <br />
                        Leveraging the findings from the keyword research, SEOptimist collaborated with SAS Design to
                        create optimized page templates. These templates were designed to utilize keywords effectively
                        in headers, meta descriptions, alt texts, and throughout web content to enhance search engine
                        rankings.
                      </li>
                      <li>
                        <strong>Code Optimization</strong>
                        <br />
                        The technical SEO team at SEOptimist implemented code optimizations to ensure the website was
                        efficiently crawlable by search engine bots. This included streamlining the site’s codebase,
                        improving load times, and ensuring mobile responsiveness.
                      </li>
                      <li>
                        <strong>Accessibility Coding</strong>
                        <br />
                        To adhere to web accessibility standards (WCAG), SEOptimist incorporated accessibility features
                        into the website’s design. This included keyboard navigability, screen reader compatibility, and
                        color contrast adjustments ensuring the site was usable for all potential users, including those
                        with disabilities.
                      </li>
                    </ol>
                    <h3>Execution</h3>
                    <p>
                      The execution phase involved close collaboration between SEOptimist and SAS Design. Regular
                      meetings ensured alignment between the SEO enhancements and the ongoing web redesign efforts.
                      SEOptimist provided detailed reports and updates to Strutt and Parker, keeping them informed of the
                      progress and impact of the SEO strategies being implemented.
                    </p>
                    <h3>Results</h3>
                    <p>
                      Post-implementation, Strutt and Parker’s website saw significant improvements in search engine
                      rankings for key terms. Specific results included:
                    </p>
                    <ul>
                      <li>An 1,000% increase in organic traffic.</li>
                      <li>Improvement in page loading speed by 35%.</li>
                      <li>An increase in click-through rates from search engine results pages.</li>
                      <li>
                        Enhanced user engagement metrics, including lower bounce rates and higher session durations.
                      </li>
                    </ul>
                    <p>
                      SEOptimist’s targeted SEO strategy for Strutt and Parker, executed in partnership with SAS Design,
                      significantly enhanced the real estate company's online visibility and user engagement. The
                      project not only improved Strutt and Parker's search engine rankings but also ensured a seamless
                      and accessible user experience.
                    </p>
                    <p>
                      This case study showcases the importance of a well-coordinated SEO strategy that aligns with web
                      design and accessibility standards, driving tangible improvements in digital marketing outcomes
                      for real estate entities.
                    </p>
                  </div>

                  <div className="col-md-4 ms-auto">
                    <img src="/img/clients/estate-agents.jpg" style={{ maxWidth: '100%', marginBottom: 30 }} alt="" />
                    <h5 className="mb-1 text-initial ps-1">
                      <u>Google results</u>
                    </h5>
                    <table className="table table-striped table-hover table-5">
                      <thead>
                        <tr>
                          <th scope="col">Keyword</th>
                          <th scope="col" style={{ minWidth: 71 }}>
                            Position{''}
                            {/* <figure
                              style={{ float: 'right' }}
                              className="itooltip itooltip-light hover-scale rounded"
                              title={'Google position in local results'}
                            >
                              <i className="uil uil-info-circle"></i>
                            </figure> */}
                          </th>

                          <th scope="col" className="text-end" style={{ minWidth: 93 }}>
                            Traffic
                            {/* <figure
                              style={{ float: 'right' }}
                              className="itooltip itooltip-light hover-scale rounded"
                              title={'Google position in local results'}
                            >
                              <i className="uil uil-info-circle"></i>
                            </figure> */}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-0">
                          <td>strutt and parker</td>
                          <td>1</td>
                          <td className="text-end">14800</td>
                        </tr>
                        <tr className="border-0">
                          <td>estate agents</td>
                          <td>9</td>
                          <td className="text-end">60500</td>
                        </tr>
                        <tr className="border-0">
                          <td>edwardian houses</td>
                          <td>1</td>
                          <td className="text-end">1900</td>
                        </tr>
                        <tr className="border-0">
                          <td>victorian house</td>
                          <td>1</td>
                          <td className="text-end">9900</td>
                        </tr>
                        <tr className="border-0">
                          <td>edwardian homes</td>
                          <td>1</td>
                          <td className="text-end">1000</td>
                        </tr>
                        <tr className="border-0">
                          <td>coastal properties for sale scotland</td>
                          <td>1</td>
                          <td className="text-end">720</td>
                        </tr>
                        <tr className="border-0">
                          <td>scottish coastal properties for sale</td>
                          <td>1</td>
                          <td className="text-end">590</td>
                        </tr>
                        <tr className="border-0">
                          <td>estate agents edinburgh scotland</td>
                          <td>1</td>
                          <td className="text-end">1300</td>
                        </tr>
                        <tr className="border-0">
                          <td>estate agents suffolk</td>
                          <td>1</td>
                          <td className="text-end">720</td>
                        </tr>
                        <tr className="border-0">
                          <td>estate agents harrogate</td>
                          <td>2</td>
                          <td className="text-end">1300</td>
                        </tr>
                        <tr className="border-0">
                          <td>estate agents in inverness</td>
                          <td>1</td>
                          <td className="text-end">480</td>
                        </tr>
                        <tr className="border-0">
                          <td>estate agents cambridge</td>
                          <td>3</td>
                          <td className="text-end">1600</td>
                        </tr>
                        <tr className="border-0">
                          <td>estate agent cambridge</td>
                          <td>1</td>
                          <td className="text-end">590</td>
                        </tr>
                        <tr className="border-0">
                          <td>houses for sale and to rent</td>
                          <td>13</td>
                          <td className="text-end">1600</td>
                        </tr>
                        <tr>
                          <td colSpan={3}>Many more keywords</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr className="border-0">
                          <td colSpan={2}>
                            <strong>Top Keywords Total</strong>
                          </td>
                          <td className="text-end">
                            <strong>97,000+</strong>
                          </td>
                        </tr>
                        <tr className="border-0">
                          <td colSpan={2}>
                            <strong>Traffic Total</strong>
                          </td>
                          <td className="text-end">
                            <strong>52,400+</strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <NextLink title="Get in touch" href="/#contact" className="more hover" />
                  {/* ========== portfolio section ========== */}
                  <LocalSEO initialslide={0} />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <ContactFooterCombo location="london" />
    </Fragment>
  );
};

export default ProjectDetails;
